/**
 * Updates the document <link rel="icon"> and <title> to match the
 * current tenant's faviconUrl + name. Falls back to the platform default
 * when no tenant or no favicon is set.
 */
import { useEffect } from "react";
import { useCurrentTenant } from "./useTenant";

const DEFAULT_FAVICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImciIHgxPSIwIiB5MT0iMCIgeDI9IjEiIHkyPSIxIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjNUNDOEZGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjMkU2QkZGIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHJ4PSIyMCIgZmlsbD0iIzBBMEYxQSIvPjx0ZXh0IHg9IjUwIiB5PSI2NiIgZm9udC1mYW1pbHk9IkludGVyLEhlbHZldGljYSxBcmlhbCIgZm9udC1zaXplPSI1MCIgZm9udC13ZWlnaHQ9IjgwMCIgZmlsbD0idXJsKCNnKSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgbGV0dGVyLXNwYWNpbmc9Ii0zIj5GWDwvdGV4dD48L3N2Zz4=";

export function useFavicon() {
  const { data } = useCurrentTenant();
  const tenant = data?.tenant;
  const faviconUrl = tenant && !tenant.isPlatform ? tenant.settings?.branding?.faviconUrl : null;
  const name = tenant && !tenant.isPlatform ? tenant.name : "AXOption";

  useEffect(() => {
    // <link rel="icon"> — there may be multiple (svg, png, sizes); replace
    // the primary one and remove any siblings so the browser doesn't keep
    // showing the default in some tabs.
    const head = document.head;
    const links = Array.from(head.querySelectorAll<HTMLLinkElement>('link[rel*="icon"]'));
    links.forEach((l, i) => { if (i > 0) l.remove(); });
    let link = links[0];
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      head.appendChild(link);
    }
    link.type = "image/png";
    link.href = faviconUrl || DEFAULT_FAVICON;
  }, [faviconUrl]);

  useEffect(() => {
    document.title = name;
  }, [name]);
}
